import { withInstall } from '@vuesax-alpha/utils'
import InputNumber from './src/input-number.vue'

export const VsInputNumber = withInstall(InputNumber)
export default VsInputNumber

export * from './src/input-number'
